import { jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { StyledLabel } from "../helpers/styled";
const Label = (props) => {
  const { size = "m", labelPosition = "start", control, ...rest } = props;
  const memoControl = useMemo(() => React.cloneElement(control, {
    ...control.props,
    size: control.props.size ?? size
  }), [size, control]);
  return /* @__PURE__ */ jsx(
    StyledLabel,
    {
      ...rest,
      control: memoControl,
      size,
      labelPlacement: labelPosition
    }
  );
};
var Label_default = Label;
export {
  Label_default as default
};
